import React, { useState, useContext } from 'react'
import Page from '../helpers/Page'
import socket from '../../modules/socket'
import { Button } from 'reactstrap'
import { SPContext } from '../../SPContext'
import './login.scss'

export const PENDING_2FA = -2
export const DELETED_2FA = -1
export const ACTIVE_2FA = 1

const Loading = ({ className }) => (
    <span className={className || ''}>
        <i className="fas fa-sync-alt fa-spin" />
    </span>
)

const Login = React.memo((props) => {
    const { setIsLoggedIn, setUserData, setUserId, setIsAdmin } = useContext(SPContext)
    const [status, setStatus] = useState('ready')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    // const [code, setCode] = useState('')
    const [mode] = useState(0)
    // const [_, setToken] = useState('')
    const loginRejected = () => {
        console.error('Login failed')
        setStatus('error')
    }
    const handleLogin = (e) => {
        e && e.preventDefault()
        if (username && password) {
            setStatus('loading')
            socket
                .auth({
                    params: {
                        username: username,
                        password: password,
                        mobile: 0,
                        portal_id: 6,
                    },
                })
                .catch(loginRejected)
                .then((response) => {
                    if (response && typeof response.user_data !== 'undefined') {
                        // console.log('login resolved', response)

                        setStatus('ready')
                        // setToken(response.user_data.token)
                        setUserData(response.user_data)
                        setUserId(response.user_data.user_id)
                        setIsLoggedIn(true)

                        if (!!response.user_data.plan_user_roles.find((user_role) => user_role === 230000)) {
                            setIsAdmin(true)
                        } else {
                            setIsAdmin(false)
                        }
                    } else {
                        loginRejected()
                    }
                })
        }
    }

    // const setError = () => {}

    return (
        <React.Fragment>
            <Page className="login-background">
                {mode === 0 && (
                    <form className="form row" onSubmit={handleLogin}>
                        <div className="col-2 offset-5 mb-3 mt-5 pt-5">
                            <img src="/images/play-plan.png" className="img-fluid" alt="Play Plan" />
                        </div>

                        <fieldset className="col-4 offset-4">
                            <div className="form-group mb-2">
                                <label htmlFor="email">
                                    <strong>Email</strong>
                                </label>
                                <input type="email" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} />
                            </div>
                            <div className="form-group mb-2">
                                <label htmlFor="email">
                                    <strong>Password</strong>
                                </label>
                                <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            <div className="form-group mb-2">
                                <Button color="primary" className="w-100 mt-3 login-button" disabled={status === 'loading'}>
                                    Login {(status === 'loading' && <Loading />) || null}
                                </Button>
                            </div>
                            {(status === 'error' && <div className="invalid">Login failed.</div>) || null}
                        </fieldset>
                    </form>
                )}
                {/* {
                    mode===PENDING_2FA && <form className="form row" onSubmit={handleTwoFAVerify}>
                        <fieldset className="col-6 offset-3">
                            <div className="form-group mb-2">
                                <label htmlFor="email">SMS code</label>
                                <input type="text" className="form-control" value={code} onChange={ e => setCode(e.target.value) } />
                            </div>
                            <div className="form-group mb-2">
                                <Button className="w-100 mt-3" disabled={status==='loading'}>
                                    Verify code { status==='loading' && <Loading /> || null }
                                </Button>
                            </div>
                        </fieldset>
                    </form>
                } */}
            </Page>
        </React.Fragment>
    )
})

export default Login
